import axios from 'axios';

const PROVIDER = 'lsport';

export default {
    data: () => ({
        infoModal: false,
        loadingInfo: false,
        currentInfoMarket: { name: '', desc: '', id: null },
        showMarketId: false,
    }),

    methods: {
        async openMarketInfo(market, object) {
            const marketId = market.id || market.marketId;
            const sportId  = object?.sport?.id;
            const lang     = this.getLanguage || 'en';

            if (!sportId) {
                //console.log('[marketInfoMixin] openMarketInfo: sportId non disponibile, chiamata API saltata.');
                return;
            }

            this.infoModal = true;
            this.loadingInfo = true;
            this.showMarketId = false;
            this.currentInfoMarket = {
                name: market.marketName,
                alias: market.marketAlias || market.marketName,
                desc: '',
                id: marketId,
                outcomes: (market.outcome || []).filter(o => o.active).slice(0, 12),
            };

            try {
                const baseUrl = process.env.VUE_APP_URL_API;
                const platformId = this.$store.getters['settings/getPlatformId'];
                const { data } = await axios.get(
                    `${baseUrl}/sport-market-mappings/sport/${sportId}?useCache=true&provider=${PROVIDER}&marketId=${marketId}&lang=${lang}&platformId=${platformId}`
                );
                const mapping = Array.isArray(data) ? data[0] : data;
                this.currentInfoMarket.desc = mapping?.description || '';
            } catch (err) {
                console.warn('[marketInfoMixin] openMarketInfo fetch failed:', err?.message);
                this.currentInfoMarket.desc = '';
            } finally {
                this.loadingInfo = false;
            }
        },
    },
};
